"use client";

import { Session } from "next-auth";
import { LuX } from "react-icons/lu";

import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetClose,
    SheetDescription,
} from "~/components/v3/shadcn/Sheet";

import {
    MobileLoggenInDescription,
    MobileLoggenOutDescription,
    MobileLoggenInFooter,
    MobileLoggenOutFooter,
} from "./MobileNavComponents";

type Props = {
    isOpen: boolean;
    closeMobileSheet: () => void;
    sessionData: Session | null;
};

export const MobileNavSheet = ({
    isOpen,
    closeMobileSheet,
    sessionData,
}: Props) => {
    return (
        <Sheet open={isOpen} onOpenChange={() => closeMobileSheet()}>
            <SheetContent
                showCloseIcon={false}
                className="z-[1000] max-w-[350px] overflow-y-scroll rounded-br-md rounded-tr-md border-none bg-[#000] p-6 pb-20"
            >
                <SheetHeader>
                    <div className="flex w-full justify-end pl-6">
                        <SheetClose className="focus:ring-ring rounded-sm opacity-90 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary">
                            <LuX className="h-7 w-7" />
                            <span className="sr-only">Close</span>
                            <div className="absolute right-0 top-0 h-[70px] w-[70px] bg-transparent" />
                        </SheetClose>
                    </div>
                </SheetHeader>

                <SheetDescription className="py-6">
                    {sessionData ? (
                        <MobileLoggenInDescription
                            sessionData={sessionData}
                            closeMobileSheet={closeMobileSheet}
                        />
                    ) : (
                        <MobileLoggenOutDescription
                            closeMobileSheet={closeMobileSheet}
                        />
                    )}
                </SheetDescription>

                {sessionData ? (
                    <MobileLoggenInFooter
                        sessionData={sessionData}
                        closeMobileSheet={closeMobileSheet}
                    />
                ) : (
                    <MobileLoggenOutFooter />
                )}
            </SheetContent>
        </Sheet>
    );
};
